import { styled } from "styled-components";
import { ImageIcon } from "../common/customImageProps";
import EditDark from "../../assets/images/editDark.png";
import EditLight from "../../assets/images/editLight.png";
import { useTheme } from "../../context/ThemeContext";
import { Squarebtn } from "../common/squareBtnProps";
import { useTheme as styledTheme } from "styled-components";
import useMediaQuery from "../../hooks/useMediaQuerryHook";

const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
`;
const Profile = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 200px;
  height: 200px;
  border-radius: 50%;
  border: 2px solid grey;
  background-color: ${({ theme }) => theme.containerbg};

  .EditIcon {
    position: absolute;
    right: 13px;
    top: 150px;
    border-radius: 50%;
    width: 36px;
    height: 36px;
      border: 1px solid grey;
     background: ${({ theme }) => theme.circularIconTextBg};
     padding: 3px;

      &:hover {
        border: 1px solid ${({ theme }) => theme.text};
      }
      &:focus {
        border: 1px solid ${({ theme }) => theme.searchInputBcgClrHver};
      }
  }
`;

const DashboardProfile: React.FC = () => {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  const styledComponentTheme = styledTheme();
  const isSmallScreen = useMediaQuery(576);
  const btnWidth = isSmallScreen ? "90%" : "40%";
  return (
    <ProfileContainer>
      <Profile>
        <button className="EditIcon">
          <ImageIcon
            src={isDarkMode ? EditLight : EditDark}
            alt="Edit icon"
            size="20px"
          />
        </button>
      </Profile>

      <Squarebtn width={btnWidth} radius="20px"
        $bacgrndColor={styledComponentTheme.text}
        $color={styledComponentTheme.circularIconTextBg}
        $hoverBackground={styledComponentTheme.circularIconTextBg}
        $hoverColor={styledComponentTheme.text}
        $margin="80px 0 0 0"
      >Update name</Squarebtn>

      <Squarebtn width={btnWidth} radius="20px"
        $bacgrndColor={styledComponentTheme.text}
        $color={styledComponentTheme.circularIconTextBg}
        $hoverBackground={styledComponentTheme.circularIconTextBg}
        $hoverColor={styledComponentTheme.text}
        $margin="20px 0 0 0"
      >Change password</Squarebtn>
    </ProfileContainer>
  );
};

export default DashboardProfile;
